import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { analytics } from './analytics/analytics';
export function sendEvent(name) {
  try {
    var event = {
      type: 'analytics:sendEvent',
      data: {
        category: 'remont',
        name: name
      },
      category: 'simple'
    };
    window.eventBus.publish(event);
  } catch (err) {
    console.error(err);
  }
}
export function sendAnalytic(name, eventData) {
  try {
    if (window.dataLayer) {
      window.dataLayer.push(_objectSpread({
        event: name
      }, eventData));
    } else {
      analytics.sendEvent(name);
    }
  } catch (err) {
    console.error(err);
  }
}